module.exports = __webpack_public_path__ + "img/money-total.69f15d9c.png";